import { playwrightUniTestkitFactoryCreator } from '@wix/wix-ui-test-utils/playwright';
import { default as TableUniDriver } from '../components/Table/Table.uni.driver';
import PickerStandaloneUniDriver from '../components/PickerStandalone/PickerStandalone.uni.driver';
import { default as PickerModalUniDriver } from '../components/PickerModal/PickerModal.uni.driver';
import { CollectionViewsDropdownUniDriver } from '../components/CollectionViewsDropdown/CollectionViewsDropdown.uni.driver';
import { CollectionSaveViewModalUniDriver } from '../components/CollectionViewsDropdown/modals/SaveView/CollectionSaveViewModal.uni.driver';
import { GridUniDriver } from '../components/Grid/Grid.uni.driver';
import { TableGridSwitchUniDriver } from '../components/TableGridSwitch/TableGridSwitch.uni.driver';
import GridFoldersUniDriver from '../components/Grid/GridFolders.uni.driver';
import TableFoldersUniDriver from '../components/TableFolders/TableFolders.uni.driver';
import TableGridSwitchFoldersUniDriver from '../components/TableGridSwitchFolders/TableGridSwitchFolders.uni.driver';
import CustomFieldsWidgetUniDriver from '../components/CustomFieldsWidget/CustomFieldsWidget.uni.driver';
import { NestedTableUniDriver } from '../components/NestedTable/NestedTable.uni.driver';
import CustomFieldsViewWidgetUniDriver from '../components/CustomFieldsWidget/CustomFieldsViewWidget.uni.driver';
import { EntityPageUniDriver } from '../components/EntityPage/EntityPage.uni.driver';
import { SettingsPageUniDriver } from '../components/SettingsPage/SettingsPage.uni.driver';
import SkeletonCardUniDriver from '../components/SkeletonCard/SkeletonCard.uni.driver';
import ErrorCardUniDriver from '../components/ErrorCard/ErrorCard.uni.driver';
import PageErrorStateUniDriver from '../components/PageErrorState/PageErrorState.uni.driver';
import { ManageTagsModalUniDriver } from '../components/Tags/ManageTags/ManageTagsModal/ManageTagsModal.uni.driver';
import CollectionPageUniDriver from '../components/CollectionPageNew/CollectionPage.uni.driver';
import RequestIdUniDriver from '../components/RequestId/RequestId.uni.driver';
import { SuggestionsUniDriver } from '../components/Suggestions/Suggestions.uni.driver';
import { default as EditableTableUniDriver } from '../components/EditableTable/EditableTable.uni.driver';

export const TableTestkit = playwrightUniTestkitFactoryCreator(TableUniDriver);

export const GridTestkit = playwrightUniTestkitFactoryCreator(GridUniDriver);

export const CustomFieldsWidgetTestkit = playwrightUniTestkitFactoryCreator(
  CustomFieldsWidgetUniDriver,
);

export const CustomFieldsViewWidgetTestkit = playwrightUniTestkitFactoryCreator(
  CustomFieldsViewWidgetUniDriver,
);

export const TableGridSwitchTestkit = playwrightUniTestkitFactoryCreator(
  TableGridSwitchUniDriver,
);

export const GridFoldersTestkit =
  playwrightUniTestkitFactoryCreator(GridFoldersUniDriver);
export const TableFoldersTestkit = playwrightUniTestkitFactoryCreator(
  TableFoldersUniDriver,
);
export const NestedTableTestkit =
  playwrightUniTestkitFactoryCreator(NestedTableUniDriver);

export const TableGridSwitchFoldersTestkit = playwrightUniTestkitFactoryCreator(
  TableGridSwitchFoldersUniDriver,
);

export const PickerStandaloneTestkit = playwrightUniTestkitFactoryCreator(
  PickerStandaloneUniDriver,
);

export const PickerModalTestkit =
  playwrightUniTestkitFactoryCreator(PickerModalUniDriver);

export const ViewsStandaloneTestkit = playwrightUniTestkitFactoryCreator(
  CollectionViewsDropdownUniDriver,
);

export const ViewsStandaloneSaveModalTestkit =
  playwrightUniTestkitFactoryCreator(CollectionSaveViewModalUniDriver);

export const EntityPageTestkit =
  playwrightUniTestkitFactoryCreator(EntityPageUniDriver);

export const SettingsPageTestkit = playwrightUniTestkitFactoryCreator(
  SettingsPageUniDriver,
);

export const SkeletonCardTestkit = playwrightUniTestkitFactoryCreator(
  SkeletonCardUniDriver,
);
export const ErrorCardTestkit =
  playwrightUniTestkitFactoryCreator(ErrorCardUniDriver);

export const PageErrorStateTestkit = playwrightUniTestkitFactoryCreator(
  PageErrorStateUniDriver,
);

export const ManageTagsModalTestkit = playwrightUniTestkitFactoryCreator(
  ManageTagsModalUniDriver,
);

export const CollectionPageTestKit = playwrightUniTestkitFactoryCreator(
  CollectionPageUniDriver,
);

export const RequestIdTestkit =
  playwrightUniTestkitFactoryCreator(RequestIdUniDriver);

export const SuggestionsTestkit =
  playwrightUniTestkitFactoryCreator(SuggestionsUniDriver);

export const EditableTableTestkit = playwrightUniTestkitFactoryCreator(
  EditableTableUniDriver,
);
